export const adFormatLabels = {
  pip: 'Picture-in-Picture',
  squeezeBack: 'Squeeze Back',
  overlay: 'Overlay',
  interstitial: 'Full Screen',
};

export const akamaiAuthTokens = ['hdnea', 'hdnts', 'hdntl'];

export const generateAkamaiToken = async (key) => {
  const acl = '/*';
  const duration = 60 * 60 * 24 * 7;
  const keyBuffer = new Uint8Array(Buffer.from(key, 'hex'));
  if (!keyBuffer.length) {
    return '';
  }
  const currentTime = Math.floor(Date.now() / 1000);
  const endTime = currentTime + duration;

  const tokenData = {
    exp: endTime,
    acl,
  };

  const tokenString = Object.keys(tokenData).reduce((acc, cur, idx, arr) => {
    cur = `${cur}=${tokenData[cur]}`;
    if (idx < arr.length - 1) {
      cur += '~';
    }
    return acc + cur;
  }, '');
  const enc = new TextEncoder();

  const tokenEnc = enc.encode(tokenString);
  const cryptoKey = await window.crypto.subtle.importKey('raw', keyBuffer, { name: 'HMAC', hash: 'SHA-256' }, false, [
    'sign',
  ]);

  const signatureArrayBuffer = await window.crypto.subtle.sign('HMAC', cryptoKey, tokenEnc);

  // Convert the ArrayBuffer to a hexadecimal string
  const signature = Array.from(new Uint8Array(signatureArrayBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return `hdnea=${tokenString}~hmac=${signature}`;
};

export const formatRequestDataHeaders = (h) => {
  return Object.keys(h).reduce((acc, cur) => {
    if (acc) {
      acc += ', ';
    }
    acc += `${cur}: ${h[cur]}`;
    return acc;
  }, '');
};

const restrictedList = {
  accept: true,
  'accept-language': true,
  'accept-charset': true,
  'accept-encoding': true,
  'access-control-request-headers': true,
  'access-control-request-method': true,
  authorization: true,
  connection: true,
  'content-length': true,
  cookie: true,
  cookie2: true,
  date: true,
  dnt: true,
  expect: true,
  'feature-policy': true,
  host: true,
  'keep-alive': true,
  origin: true,
  'proxy-': 'proxy-',
  'sec-': 'sec-',
  te: true,
  trailer: true,
  'transfer-encoding': true,
  upgrade: true,
  via: true,
  'user-agent': true,
  referer: true,
  'x-amzn-trace-id': true,
  'x-amz-cf-id': true,
  'x-forwarded-for': true,
  'x-forwarded-port': true,
  'x-forwarded-proto': true,
  'x-playback-session-id': true,
  priority: true,
};

export const filterRestrictedHeaders = (headers) => {
  return Object.keys(headers)
    .filter((h) => {
      const lowerH = h.toLowerCase();
      const [leader] = lowerH.split('-');
      if (leader) {
        const start = `${leader}-`;
        if (restrictedList[start] && restrictedList[start] !== true) {
          return !h.startsWith(restrictedList[start]);
        }
      }
      return !restrictedList[lowerH];
    })
    .reduce((obj, key) => {
      obj[key] = headers[key];
      return obj;
    }, {});
};

export const accountPlaybackUrl = (accountSubdomain, accountId) => {
  const prefix = accountSubdomain || accountId;
  try {
    if (COMPOSER_INTEGRATION_PLAYBACK) {
      return COMPOSER_INTEGRATION_PLAYBACK.replace('integration', `${prefix}.integration`);
    }
  } catch (error) {
    //
  }
  return COMPOSER_GLOBAL_PLAYBACK.replace('global', `${prefix}.global`);
};
